//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inject:['reload'],
  name: "common-default-images",
  props: {
    year: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 9,
    },
    isM: {
      type: Boolean,
      default: false,
    },    from: {
      type: Number,
      default: 0,
    },
    width: {
      type: Boolean,
      default: false,
    },
    buyBut: {
      type: Number,
      default: 0,
    },
    isPlanContains: {
      type: Boolean,
      default: false,
    },
    planContains: {
      type: String,
      default: '',
    },
  },
  methods: {
    jumpCourse() {
      this.$router.push('/courseIndex?year='+this.year);
      this.reload();
    },
    changeTrue() {
      if (this.from == 0) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 0,
          },
        });
      }
      if (this.from == 1) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 1,
          },
        });
      } else if (this.from == 2) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 2,
          },
        });
      } else if (this.from == 3) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 3,
          },
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common-default-images.vue